import React from 'react'
import Text from '../../components/shared/ui/text'
import Box from '../../components/shared/ui/box'
import EventsDisplayItem from './eventsDisplayItem'

class EventsDisplay extends React.Component<any, any> {
  render() {
    return (
      <Box>
        {this.props.data.map((eventsGroupedByDate, index) => {
          return (
            <Box key={index}>
              <Text is="h2">{eventsGroupedByDate[0]}</Text>
              <EventsDisplayItem
                data={eventsGroupedByDate[1]}
                details={this.props.details}
                onShowDetails={this.props.onShowDetails}
                onCloseDetails={this.props.onCloseDetails}
              />
            </Box>
          )
        })}
      </Box>
    )
  }
}

export default EventsDisplay
